<div class="form" [formGroup]="form">
  <div class="form__col">
    <mat-form-field appearance="outline">
      <mat-label i18n="@@Phone">Phone</mat-label>
      <input matInput formControlName="phone" readonly>
      <mat-error *ngIf="form.controls?.phone?.hasError('required')" i18n="@@ErrorMessageRequired">Required</mat-error>
    </mat-form-field>
  </div>
  <div class="form__col">
    <mat-form-field appearance="outline">
      <mat-label i18n="@@Email">Email</mat-label>
      <input
        matInput
        required
        formControlName="email"
        name="email"
        type="email"
        (keydown)="onSubmit($event)">
      <mat-error *ngIf="form.controls?.email?.hasError('email') && !form.controls?.email?.hasError('required')" i18n="@@ErrorMessageIncorectEmail">E-mail isn't valid</mat-error>
      <mat-error *ngIf="form.controls?.email?.hasError('required')" i18n="@@ErrorMessageRequired">Required</mat-error>
    </mat-form-field>
  </div>
  <div class="form__col">
    <mat-form-field appearance="outline">
      <mat-label i18n="@@Name">Name</mat-label>
      <input matInput formControlName="name">
      <mat-error *ngIf="form.controls?.name?.hasError('required')" i18n="@@ErrorMessageRequired">Required</mat-error>
    </mat-form-field>
  </div>
  <div class="form__col" *ngIf="{
    fromRussia: fromRussia$ | async,
    personalDataPolicyPage: personalDataPolicyPage$ | async,
    personalDataConsentPage: personalDataConsentPage$ | async,
    additionalPrivacy: additionalPrivacy$ | async
  } as data">
    <mat-checkbox color="accent" formControlName="acceptedPersonalDataProcessingPolicy">
      <span 
        class="small"
        *ngIf="data.fromRussia && data.personalDataPolicyPage && data.personalDataConsentPage"
        [innerHTML]="agreementMessage | safeHTML"
      ></span>
      <span 
        class="small"
        *ngIf="(!data.fromRussia || !data.personalDataPolicyPage || !data.personalDataConsentPage) && data.additionalPrivacy"
        [innerHTML]="agreementMessageDeprecated | safeHTML"
      ></span>
    </mat-checkbox>
    <div class="message message--error small" i18n="@@PersonalDataRequiredError" *ngIf="form.controls?.acceptedPersonalDataProcessingPolicy?.hasError('required')">Accept the agreement to register.</div>
  </div>

  <div class="form__col">
    <mat-checkbox color="accent" formControlName="acceptedMarketingCommunications">
      <span class="small" i18n="@@ConsentPromotionalData">I consent to receiving information about promotions, special offers, and interesting events.</span>
    </mat-checkbox>
  </div>
</div>
